import { graphql, navigate, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { FlowIdTypes } from '@folx-types/flow';
import { IFlowStepProps } from '@folx-types/flow-steps';

import {
	ConfirmedPaymentNotRequiredStep,
	IConfirmedPaymentNotRequiredStepContent,
} from './ConfirmedPaymentNotRequiredStep.component';

interface IConfirmedPaymentNotRequiredPageStepProps extends IFlowStepProps {
	serviceType?: FlowIdTypes;
	path: string;
}

const ConfirmedPaymentNotRequiredPageStep: FC<IConfirmedPaymentNotRequiredPageStepProps> = ({
	serviceType,
}) => {
	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-appointment-confirmed-payment-not-required" }) {
				appointment_header
				appointment_subheader
				appointment_description
				location_subheader
				location_description
				cancellation_header
				cancellation_description
				edit_label
				interpreter_info
				continue_label
			}
		}
	`);

	const { existingFormData } = useContext(FlowContext);

	const handleResetStatus = () => {
		navigate(`/app/member/appointments/reschedule/${existingFormData?.cogsworthId}`);
	};

	const refinedContent: IConfirmedPaymentNotRequiredStepContent = keysToCamel(
		pageContent
	) as IConfirmedPaymentNotRequiredStepContent;

	return (
		<ConfirmedPaymentNotRequiredStep
			existingFormData={existingFormData}
			pageContent={refinedContent}
			handleResetStatus={handleResetStatus}
			errorPath={`/app/flows/appointment_booking/${serviceType}/error`}
			appointmentNotConfirmedPath={`/app/flows/appointment_booking/${serviceType}/not_confirmed`}
		/>
	);
};

export default ConfirmedPaymentNotRequiredPageStep;
